import type { components } from "../api/generated/survey-svc";
import { surveyClient, unauthenticatedSurveyFetch } from "../api/survey-client";
import appConfig from "../configs/app.config";

export function apiSignIn(data: components["schemas"]["AuthSigninParams"]) {
  return surveyClient.signIn(data);
}

export function apiRequestEmailCode(
  data: components["schemas"]["AuthEmailCodeRequestParams"],
) {
  return surveyClient.requestEmailCode(data);
}

export function apiVerifyEmailCode(
  data: components["schemas"]["AuthEmailCodeVerifyParams"],
) {
  return surveyClient.verifyEmailCode(data);
}

export function apiResendEmailCode(
  data: components["schemas"]["AuthEmailCodeResendParams"],
) {
  return surveyClient.resendEmailCode(data);
}

export function apiTwoFactorAuthentication(
  data: components["schemas"]["AuthTwoFactorAuthenticationParams"],
) {
  return surveyClient.twoFactorAuthentication(data);
}

export function apiCompleteProviderAuthentication(
  data: components["schemas"]["AuthProviderCompletionParams"],
) {
  return surveyClient.completeProviderAuthentication(data);
}

export function apiCompleteProviderRegistration(
  data: components["schemas"]["AuthProviderRegistrationParams"],
) {
  return surveyClient.completeProviderRegistration(data);
}

export function apiSignUp(data: components["schemas"]["AuthSignupParams"]) {
  return surveyClient.signUp(data);
}

export async function apiInvitationSignUp(
  data: Omit<components["schemas"]["AuthSignupParams"], "company"> & {
    invitationToken: string;
  },
) {
  try {
    const response = await unauthenticatedSurveyFetch(
      `${appConfig.indicafixSurveySvcUrl}/auth/signup/invitation`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      },
    );
    const body = await response.json().catch(() => undefined);
    return response.ok
      ? {
          status: "success" as const,
          data: body as components["schemas"]["AuthSignin"],
        }
      : {
          status: "http-error" as const,
          statusCode: response.status,
          error: body,
        };
  } catch (error: unknown) {
    return { status: "network-error" as const, error };
  }
}

export function apiSignOut() {
  return surveyClient.signOut();
}

export function apiMe() {
  return surveyClient.currentUser();
}

export function apiForgotPassword(
  data: components["schemas"]["AuthForgotPasswordParams"],
) {
  return surveyClient.forgotPassword(data);
}

export function apiResetPassword(
  data: components["schemas"]["AuthResetPasswordParams"],
) {
  return surveyClient.resetPassword(data);
}
